export function createGridPass(ctx) {
    const { regl } = ctx;
    const cmd = regl({
        vert: `
      precision highp float;
      attribute vec2 position;
      uniform vec2 viewport;
      void main() {
        vec2 ndc = (position / viewport) * 2.0 - 1.0;
        gl_Position = vec4(ndc.x, -ndc.y, 0.0, 1.0);
      }
    `,
        frag: `
      precision highp float;
      uniform vec4 color;
      void main() { gl_FragColor = color; }
    `,
        attributes: {
            position: regl.prop('positions'),
        },
        uniforms: {
            viewport: regl.prop('viewport'),
            color: regl.prop('color'),
        },
        primitive: 'lines',
        count: (_c, p) => p.count,
        blend: {
            enable: true,
            func: { src: 'src alpha', dst: 'one minus src alpha' },
        },
    });
    function drawLines(positions, color) {
        if (positions.length < 4)
            return;
        cmd({
            positions,
            viewport: [ctx.sizePx.width, ctx.sizePx.height],
            color: [...color],
            count: positions.length / 2,
        });
    }
    return {
        draw(spec) {
            drawLines(spec.minor, spec.minorColor);
            drawLines(spec.major, spec.majorColor);
        },
        destroy() {
            // released via regl.destroy()
        },
    };
}
//# sourceMappingURL=grid-pass.js.map